module.exports = __webpack_public_path__ + "static/media/web.2616fb59.jpg";